export default "__VITE_ASSET__BSO$L_Di__"